module.exports = __webpack_public_path__ + "img/64.680cd93c.png";